import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ChangableComponent } from '@app/models/changable.component';
import { DeviceOrientationEnum, PlatformService, ScreenService } from '@core/services';
import { ErrorNotificationService } from '@shared/error-notification/error-notification.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { takeUntil, tap } from 'rxjs/operators';
import { StepByStepWizardSteps } from './models';

@Component({
  selector: 'app-step-by-step-wizard',
  templateUrl: './step-by-step-wizard.component.html',
  styleUrls: ['./step-by-step-wizard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepByStepWizardComponent<T> extends ChangableComponent implements OnInit {
  @Input()
  public steps: StepByStepWizardSteps<T>;

  @Input()
  public showSteps: boolean = true;

  @Input()
  public showHeader = false;

  @Input()
  public showFooter = false;

  public isSafari = this.screenService.isSafari;
  public activeStep: string;

  public constructor(
    private screenService: ScreenService,
    public errorNotificationService: ErrorNotificationService,
    public deviceService: DeviceDetectorService,
    protected readonly cdr: ChangeDetectorRef,
    protected readonly platform: PlatformService,
  ) {
    super(cdr, platform);
  }

  public ngOnInit() {
    this.steps.activeStep$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: () => {
        this.detectChanges();
      },
      error: (error) => {
        this.errorNotificationService.captureError(error, 'OTHER-PROBLEM');
      },
    });
  }

  public onStepChanged(event) {
    this.activeStep = event;
  }

  public get screenClasses() {
    const isPortrait = this.screenService.deviceOrientation === DeviceOrientationEnum.portrait;
    return {
      tablet: this.deviceService.isTablet(),
      mobile: this.deviceService.isMobile(),
      desktop: (!this.deviceService.isTablet() && !this.deviceService.isMobile()) || this.deviceService.isDesktop(),
      portrait: !this.deviceService.isDesktop() && isPortrait,
      landscape: !this.deviceService.isDesktop() && !isPortrait,
    };
  }
}
